export default class ShippersDeclarationModel {
    constructor(raw = {}) {
        this.shipper = raw.shipper ?? "";
        this.airWayBillNo = raw.airWayBillNo ?? "";
        this.page = raw.page ?? "";
        this.ofPage = raw.ofPage ?? "";
        this.shippersRefNo = raw.shippersRefNo ?? "";
        this.consignee = raw.consignee ?? "";
        this.airportOfDeparture = raw.airportOfDeparture ?? "";
        this.airportOfDestination = raw.airportOfDestination ?? "";
        this.shipmentType = raw.shipmentType ?? "";
        this.passengerOrCargoAircraft = raw.passengerOrCargoAircraft ?? "PASSENGER AND CARGO AIRCRAFT";
        this.radioactive = raw.radioactive ?? "";
        this.additionalHandlingInformation = raw.additionalHandlingInformation ?? "";
        this.nameOfSignatory = raw.nameOfSignatory ?? "";
        this.date = raw.date ?? "";
        this.unOrIdNo = raw.unOrIdNo ?? "";
        this.properShippingName = raw.properShippingName ?? "";
        this.classOrDivision = raw.classOrDivision ?? "";
        this.packingGroup = raw.packingGroup ?? "";
        this.quantityAndTypeOfPacking = raw.quantityAndTypeOfPacking ?? "";
        this.packingInst = raw.packingInst ?? "";
        this.authorization = raw.authorization ?? "";

        this.hasPassengerAndCargoAirCraft = raw.hasPassengerAndCargoAirCraft ?? "PASSENGER AND CARGO AIRCRAFT";
        this.hasCargoAirCraftOnly = raw.hasCargoAirCraftOnly ?? "CARGO AIRCRAFT ONLY";
        this.hasRadioActive = raw.hasRadioActive ?? "RADIOACTIVE";
        this.hasNonRadioActive = raw.hasNonRadioActive ?? "NON-RADIOACTIVE";
    }
}
